import { defineAsyncComponent, reactive, toRaw } from 'vue';
import i18n from '../../../../i18n';
import store from '../../../../store';
import { createLoading } from '../../../../utils/loading';


import { required, validateError } from '../../../../utils/validate';
import { useForm as createUseForm } from '@ant-design-vue/use';
import { addModal, setIsLoading as setIsLoadingApp } from '../../../../app.logic';
import {
    checkAttribute,
    initUseForm,
    onClickView
} from '../../../../utils/form';

import {
    createFieldRadioGroup,
} from '../../../../components/input/template-builder/template-builder.logic';
import { modalStyleForm } from '../../../../utils/constant';
import lodash from 'lodash';
import { Modal } from 'ant-design-vue';
export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = 'resource/v1/transaction/samplingProduct';
export const routerPrefix = 'sampling-products';

export const callSave = ({ form }) => store.dispatch(`${actionPrefix}/save`, { data: form });
export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });
export const callActive = ({ id }) => store.dispatch(`${actionPrefix}/active`, { id });
export const callArchive = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id });
export const callDelete = ({ id }) => store.dispatch(`${actionPrefix}/delete`, {
    id,
    config: { params: { isHardDelete: true } }
});
export const callActiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/activeAll`, { ids });
export const callArchiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids });
export const callDeleteAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, {
    ids,
    config: { params: { isHardDelete: true } }
});
export const callChanges = ({ id, criteria }) => store.dispatch(`${actionPrefix}/changes`, { id, criteria });
export const callSamplingRepeatIntends = () => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', { group: 'SAMPLING_REPEAT_INTEND' });

const SamplingRepeatIntendForm = defineAsyncComponent(() => import('./SamplingRepeatIntendForm'));


export const fetchData = ({ props }) => {
    const { fetchCriteria } = props;
    if (!fetchCriteria || !fetchCriteria?.where) {
        return Promise.resolve({ data: [] });
    }
    setIsLoading(true);
    return callSearch({ criteria: fetchCriteria }).finally(() => setIsLoading(false));
};

export const onClickSave = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => {
            setIsLoadingApp(true);
            return callSave({ form: data.useForm.modelRef })
                .finally(() => setIsLoadingApp(false))
                .then((record) => onClickView({ record, routerPrefix }));
        })
        .catch((error) => validateError({ error }));
};

export const onClickModalOk = ({ data, afterSaveCallback }) => {
    return data.useForm
        .validate()
        .then(() => {
            const record = { ...toRaw(data.useForm.modelRef), isSave: true };
            Modal.confirm({
                title: i18n.global.t("model.samplingProduct.labels.confirmSendSamplingRepeatIntend"),
                content: `ท่านยืนยันแจ้ง ${ record.refSamplingRepeatIntend?.value } หมายเลขตัวอย่าง ${ record.samplingNo } โดยเมื่อยืนยันแล้วจะไม่สามารถแก้ไขความประสงค์ได้ภายหลัง`,
                autoFocusButton: "cancel",
                onOk: () => {
                    setIsLoadingApp(true);
                    return callSave({ form: record })
                        .then(() => afterSaveCallback?.())
                        .finally(() => setIsLoadingApp(false))
                },
            });
        })
        .catch((error) => {
            validateError({ error });
            throw error;
        });
};

export const createSearchOneCriteria = ({ id, forLog }) => {
    if (!forLog) {
        return {
            select: ['**'],
            page: 0,
            size: 1,
            where: [{ name: 'id', type: 'UUID', operator: '=', value: id }]
        };
    } else {
        return {
            select: [],
            page: 0,
            size: 1,
            where: [{ name: 'id', type: 'UUID', operator: '=', value: id }],
            children: [{ name: 'children', select: ['name'], page: 0, size: 1000000, isRecursive: true }]
        };
    }
};


export const openModalForm = ({ props, afterSaveCallback }) => {
    const refs = reactive({ form: null });
    const options = addModal({
        bind: lodash.merge(lodash.cloneDeep(modalStyleForm), {
            width: '50%',
            okButtonProps: { disabled: props.viewOnly },
            header: i18n.global.t('model.samplingProduct.labels.samplingRepeatIntendForm'),
            onOk: () => {
                refs.form.callOnClickModalOk({ afterSaveCallback })
                    .then(() => {
                        options.bind.onCancel();
                    });
            }
        }),
        render: () => <SamplingRepeatIntendForm ref={(e) => {
            if (e) refs.form = e;
        }} {...props}></SamplingRepeatIntendForm>
    });
    return options;
};

export const createForm = () => {
    return {
        refSamplingRepeatIntend: null
    };
};

export const createRules = () => {
    return {
        refSamplingRepeatIntend: [required]
    };
};

export const createField = ({ props, data }) => {
    const viewOnly = props.viewOnly;
    const useForm = data.useForm;
    const modelRef = useForm.modelRef;
    return [
        createFieldRadioGroup({
            key: `refSamplingRepeatIntend`,
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            inputProp: () => ({
                value: modelRef.refSamplingRepeatIntend,
                'onUpdate:value': value => (modelRef.refSamplingRepeatIntend = value),
                disabled: viewOnly || modelRef.refSamplingRepeatIntend,
                list:() => callSamplingRepeatIntends().then(list => list.filter(it => it.key != "Expired")),
                optLabel: 'value'
            })
        })
    ];
};

export const loadForm = ({ props, data }) => {
    setIsLoading(true);
    const { form } = props;
    const { id, useForm } = data;
    const { modelRef } = useForm;
    let promise = null;
    if (form) {
        promise = Promise.resolve({ data: [form] });
    } else if (id) {
        promise = callSearch({ criteria: createSearchOneCriteria({ id }) });
    } else {
        promise = Promise.resolve({ data: [modelRef] });
    }
    return promise
        .then(page => initUseForm({ data, page, routerPrefix }))
        .then(() => loadDefaultForm({ props, data }))
        .finally(() => setIsLoading(false));
};


export const loadDefaultForm = ({ data }) => {
    const promises = [];
    promises.push(Promise.all([callSamplingRepeatIntends()])
        .then(arr => {
            data.samplingRepeatIntends = arr[0];
        }));
    return Promise.all(promises);
};

export const initForm = ({ props, data, refs }) => {
    checkAttribute({ props, data, refs });
    data.form = createForm();
    data.rules = createRules();
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs });
    loadForm({ props, data, refs });
};





